module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/th-card-drag.30109ea83df6ea002e84.gif";